import { create } from "zustand";

const useOrderItemsStore = create((set) => ({
  orderItems: [],

  removeOrderItem: (index) =>
    set((state) => ({
      orderItems: state.orderItems.filter(
        (_, itemIndex) => itemIndex !== index
      ),
    })),

  addOrderItem: (item) =>
    set((state) => ({
      orderItems: [...state.orderItems, item],
    })),

  clearOrderItems: () =>
    set({
      orderItems: [],
    }),

  setOrderItems: (items) => set({ orderItems: items }),

  updateOrderItem: (index, updatedItem) =>
    set((state) => ({
      orderItems: state.orderItems.map((item, i) =>
        i === index ? { ...item, ...updatedItem } : item
      ),
    })),
}));

export default useOrderItemsStore;
